import React from 'react'

const LImage = () => {
  return (
    <div>
        <img src="https://www.netmeds.com/images/cms/wysiwyg/cms/1635266868_WhatsApp_Image_2021-10-26_at_21.56.07.jpg" alt="Image1" />
    </div>
  )
}

export default LImage